<template>
  <div v-if="billingInfo">
    <div v-if="billingInfo.SetUp">
      <billing-info-table :data="billingInfo.BillingCustomer" />
    </div>
    <div v-else>
      <div>
        <sui-message>
          <sui-message-header>Please enter billing information</sui-message-header>
          <p>Please enter billing information.<br/>
          You will <b>not</b> be charged anything at this stage</p>
        </sui-message>
      </div>
      <sui-divider />
      <sui-form>
        <sui-form-field>
          <label>Full Name *</label>
          <input placeholder="Full Name" v-model="fullName" >
        </sui-form-field>
        <sui-form-field>
          <label>Address Line 1 *</label>
          <input placeholder="Address Line 1" v-model="address1" >
        </sui-form-field>
        <sui-form-field>
          <label>Address Line 2</label>
          <input placeholder="Address Line 2" v-model="address2" >
        </sui-form-field>
        <sui-form-field>
          <label>City / Town *</label>
          <input placeholder="City / Town" v-model="city">
        </sui-form-field>
        <sui-form-field>
          <label>Post Code *</label>
<!--          <input placeholder="Post Code" v-model="postCode" >-->
          <input placeholder="Post Code" type="text" :value="postCode.toUpperCase()" @input="postCode = $event.target.value.toUpperCase()">
        </sui-form-field>
        <sui-divider />
        <sui-button type="button" class='pay-with-stripe' @click='saveBilling' :disabled='!isValid' primary>Save</sui-button>
      </sui-form>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import SuiDivider from "semantic-ui-vue/dist/commonjs/elements/Divider/Divider";

  export default {
    name: "BillingInfo",
    components: {SuiDivider},
    data () {
      return {
        fullName: "",
        address1: "",
        address2: "",
        city: "",
        postCode: "",
      }
    },
    computed: {
      isValid: function () {
        if (this.fullName.trim() === "") return false
        if (this.address1.trim() === "") return false
        // if (this.address2.trim() === "") return false
        if (this.city.trim() === "") return false
        if (this.postCode.trim() === "") return false
        return true
      },
      // mix this into the outer object with the object spread operator
      ...mapState({
        billingInfo: state => (state.billing || {}).getBillingResponse,
      })
    },
    methods: {
      reset () {
        this.fullName = ""
        this.address1 = ""
        this.address2 = ""
        this.city = ""
        this.postCode = ""
      },
      async saveBilling ()  {
        await this.$store.dispatch('billing/saveBilling', {
          fullName: this.fullName,
          address1: this.address1,
          address2: this.address2,
          city: this.city,
          postCode: this.postCode,
        })
        if (this.$store.state.billing.saveBillingResponse) {
          this.$store.dispatch('billing/getBilling')
        }
      }
    },
    mounted() {
      this.reset()
    }
  }
</script>

<style scoped>
  .stripe-card {
    /*background: #FAFAFA;*/
    border: 1px solid #E0E0E0;
    padding: 5pt 5pt;
    border-radius: 5pt;
  }
  .stripe-card.complete {
    border-color: rgba(0, 128, 0, 0.2);
    background: rgba(0, 128, 0, 0.01);
  }
</style>
